
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MessageBox';
import { detailsOrder } from '../features/OrderDetailsSlice';
import { deliverOrder, resetDeliverOrder } from '../features/DeliverOrderSlice';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { payOrder, resetPayOrder } from '../features/payOrderSlice';
import { getOrderItems } from '../features/OrderItemSlice';
import { IMAGE_URL } from '../components/utils';

export default function OrderScreen() {
    const { id } = useParams();
    const auth = useSelector(state => state.auth);
    const { userInfo } = auth;
    const dispatch = useDispatch();
    const payOrderData = useSelector(state => state.payOrderData);
    const { status: payStatus, error: payError} = payOrderData;
    const orderDetails = useSelector((state) => state.orderDetails);  
    const { orderDetailsError, orderDetailsData, orderDetailsStatus} = orderDetails;
    const { orderItemsError, orderItemsData, orderItemsStatus} =useSelector(state => state.orderItems);

    const orderDeliver = useSelector(state => state.orderDeliver);
    const {status: deliverStatus, error: deliverError } = orderDeliver;

    const deliverHandler = () => {
      dispatch(deliverOrder(orderDetailsData.id));
    }

    const successPaymentHandler = (data) => {
      //TODO implement successpaymenthandler
      dispatch(payOrder({id: orderDetailsData.id, data}));

    }
    
      
    useEffect(() => {
    
      if (!orderDetailsData || deliverStatus === 'success' || payStatus === 'success' || (orderDetailsData && orderDetailsData.id !== id)) {
        dispatch(resetDeliverOrder());  
        dispatch(resetPayOrder());      
        dispatch(detailsOrder(id));
        dispatch(getOrderItems(id));
      } 
    },[dispatch, id, orderDetailsData.id, deliverStatus, payStatus]);
    
  return (
    <div>
      <div>
        <h1>Order {orderDetailsData._id}</h1>
        {payStatus === "pending" && (<LoadingBox>Loading...</LoadingBox>)}
        {payStatus === "rejected" && (<MessageBox variant="danger">{payError}</MessageBox>)}
        {orderDetailsStatus === "pending" && (<LoadingBox>Loading...</LoadingBox>)}
        {orderDetailsStatus === "rejected" && (<MessageBox variant="danger">{orderDetailsError}</MessageBox>)}
        {deliverStatus === "pending" && (<LoadingBox>Loading...</LoadingBox>)}
        {deliverStatus === "rejected" && (<MessageBox variant="danger">{deliverError}</MessageBox>)}
        {orderDetailsStatus === 'success' && (
        <div className="row top">
            <div className="col-2">
                <ul>
                    <li>
                        <div className="card card-body">
                            <h2>Shipping</h2>
                            <p>
                                <strong>Name:</strong> {orderDetailsData.full_name} <br />
                                <strong>Address:</strong> {orderDetailsData.address},
                                {orderDetailsData.city}, {orderDetailsData.postal_code}
                                ,{orderDetailsData.country}
                            </p>
                            {orderDetailsData.is_delivered ? (
                              <MessageBox variant="success">Delivered at: {orderDetailsData.delivered_at}</MessageBox> )
                              : (
                                <MessageBox variant="danger">Not Delivered</MessageBox>
                              )
                            }
                        </div>
                    </li>
                    <li>
                        <div className="card card-body">
                            <h2>Payment</h2>
                            <p><strong>Method:</strong> {orderDetailsData.payment_method}</p>
                            {orderDetailsData.is_paid ? (
                              <MessageBox variant="success">Paid at: {orderDetailsData.paid_at}</MessageBox> )
                              : (
                                <MessageBox variant="danger">Not Paid</MessageBox>
                              )
                            }
                        </div>
                    </li>
                    <li>
                        <div className="card card-body">
                        {orderItemsStatus === "pending" && (<LoadingBox>Loading items...</LoadingBox>)}
                        {orderItemsStatus === "rejected" && (<MessageBox variant="danger">{orderItemsError}</MessageBox>)}
                        {orderItemsStatus === "success" && (
                          <>
                          <h2>Order Items</h2>
                          <ul>
                          {
                          orderItemsData.map((item) => (
                              <li key={item.id}>
                                  <div className="row">
                                      <div>
                                      <img className="small"
                                              src={IMAGE_URL + item.image}
                                              alt={item.name}
                                      ></img>
                                      </div>
                                      <div className="min-30">
                                          <Link to={`/product/${item.id}`}>{item.name}</Link>
                                      </div>
                                      <div>{item.cart_qty} x {item.price} = {item.cart_qty * item.price}</div>
                                  </div>
                              </li>
                          ))}
                          </ul>
                          </>
                        )}
                            
                        </div>
                    </li>
                </ul>
            </div>
            <div className="col-1">
                <div className="card card-body">
                    <ul>
                        <li>
                            <h2>Order Summary</h2>
                        </li>
                        <li>
                            <div className="row">
                                <div>Item</div>
                                <div>${orderDetailsData.items_price.toFixed(2)}</div>
                            </div>
                        </li>
                        <li>
                            <div className="row">
                                <div>Shipping</div>
                                <div>${orderDetailsData.shipping_price.toFixed(2)}</div>
                            </div>
                        </li>
                        <li>
                            <div className="row">
                                <div>Tax</div>
                                <div>${orderDetailsData.tax_price.toFixed(2)}</div>
                            </div>
                        </li>
                        <li>
                            <div className="row">
                                <div>
                                    <strong>Order Total</strong>
                                </div>
                                <div><strong>${orderDetailsData.total_price.toFixed(2)}</strong></div>
                            </div>
                        </li>
                          {!orderDetailsData.is_paid ? (
                             <li>
                          <PayPalButtons 
                            createOrder={(data, actions) => {
                              return actions.order.create({
                                purchase_units: [{
                                  description: orderDetailsData.description,
                                  amount: {
                                    value: orderDetailsData.total_price,
                                    country: "EUR",
                                  }
                                }]
                              });
                            }}
                            onApprove={async(data, actions) => {
                              const order = await actions.order.capture();
                              console.log("Order: ", order);
                              console.log("PaymentResult:", data);
                              successPaymentHandler(data);
                            }}
                          />
                        </li>
                          )
                        : (
                          <li>
                            Your Order is Paid.
                          </li>                        )
                        }
                        {
                          ( userInfo.is_admin && orderDetailsData.is_paid && !orderDetailsData.is_delivered) ? (
                            <li>
                              <button type='button' onClick={deliverHandler} className='primary block'>
                                Deliver Order
                              </button>
                            </li>
                          ) : ''
                        }
                    </ul>
                </div>
            </div>
        </div>
        )}
    </div>
  </div>
)
}